import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MeetingRegistration from './MeetingRegistration';
import PaymentSuccess from './PaymentSuccess';
import PaymentFailed from './PaymentFailed';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MeetingRegistration />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/payment-failed" element={<PaymentFailed />} />
      </Routes>
    </Router>
  );
}

export default App;
